const EventEmitter = require('events');
const { isRunningInNode } = require('../action/common');
let general_event;
if (isRunningInNode()) {
  general_event = new EventEmitter();
}

module.exports = general_event;